<!-- START: icons/linear-icons-free -->
<section class="card">
    <div class="card-header">
        <span class="cat__core__title">
            <strong>Linear Icons Free</strong>
            <a href="https://linearicons.com/free" target="_blank" class="btn btn-sm btn-primary ml-2">Official Documentation <i class="icmn-link ml-1"><!-- --></i></a>
        </span>
    </div>
    <div class="card-block">
        <div class="row">
            <div class="col-xl-6 offset-xl-3">
                <ul class="cat__core__icons-block list-unstyled">
                    <li><i class="lnr lnr-home"></i></li>
                    <li><i class="lnr lnr-apartment"></i></li>
                    <li><i class="lnr lnr-pencil"></i></li>
                    <li><i class="lnr lnr-magic-wand"></i></li>
                    <li><i class="lnr lnr-drop"></i></li>
                    <li><i class="lnr lnr-lighter"></i></li>
                    <li><i class="lnr lnr-poop"></i></li>
                    <li><i class="lnr lnr-sun"></i></li>
                    <li><i class="lnr lnr-moon"></i></li>
                    <li><i class="lnr lnr-cloud"></i></li>
                    <li><i class="lnr lnr-cloud-upload"></i></li>
                    <li><i class="lnr lnr-cloud-download"></i></li>
                    <li><i class="lnr lnr-cloud-sync"></i></li>
                    <li><i class="lnr lnr-cloud-check"></i></li>
                    <li><i class="lnr lnr-database"></i></li>
                    <li><i class="lnr lnr-lock"></i></li>
                    <li><i class="lnr lnr-cog"></i></li>
                    <li><i class="lnr lnr-trash"></i></li>
                    <li><i class="lnr lnr-dice"></i></li>
                    <li><i class="lnr lnr-heart"></i></li>
                    <li><i class="lnr lnr-star"></i></li>
                    <li><i class="lnr lnr-star-half"></i></li>
                    <li><i class="lnr lnr-star-empty"></i></li>
                    <li><i class="lnr lnr-flag"></i></li>
                    <li><i class="lnr lnr-envelope"></i></li>
                    <li><i class="lnr lnr-paperclip"></i></li>
                    <li><i class="lnr lnr-inbox"></i></li>
                    <li><i class="lnr lnr-eye"></i></li>
                    <li><i class="lnr lnr-printer"></i></li>
                    <li><i class="lnr lnr-file-empty"></i></li>
                    <li><i class="lnr lnr-file-add"></i></li>
                    <li><i class="lnr lnr-enter"></i></li>
                    <li><i class="lnr lnr-exit"></i></li>
                    <li><i class="lnr lnr-graduation-hat"></i></li>
                    <li><i class="lnr lnr-license"></i></li>
                    <li><i class="lnr lnr-music-note"></i></li>
                    <li><i class="lnr lnr-film-play"></i></li>
                    <li><i class="lnr lnr-camera-video"></i></li>
                    <li><i class="lnr lnr-camera"></i></li>
                    <li><i class="lnr lnr-picture"></i></li>
                    <li><i class="lnr lnr-book"></i></li>
                    <li><i class="lnr lnr-bookmark"></i></li>
                    <li><i class="lnr lnr-user"></i></li>
                    <li><i class="lnr lnr-users"></i></li>
                    <li><i class="lnr lnr-shirt"></i></li>
                    <li><i class="lnr lnr-store"></i></li>
                    <li><i class="lnr lnr-cart"></i></li>
                    <li><i class="lnr lnr-tag"></i></li>
                    <li><i class="lnr lnr-phone-handset"></i></li>
                    <li><i class="lnr lnr-phone"></i></li>
                    <li><i class="lnr lnr-pushpin"></i></li>
                    <li><i class="lnr lnr-map-marker"></i></li>
                    <li><i class="lnr lnr-map"></i></li>
                    <li><i class="lnr lnr-location"></i></li>
                    <li><i class="lnr lnr-calendar-full"></i></li>
                    <li><i class="lnr lnr-keyboard"></i></li>
                    <li><i class="lnr lnr-spell-check"></i></li>
                    <li><i class="lnr lnr-screen"></i></li>
                    <li><i class="lnr lnr-smartphone"></i></li>
                    <li><i class="lnr lnr-tablet"></i></li>
                    <li><i class="lnr lnr-laptop"></i></li>
                    <li><i class="lnr lnr-laptop-phone"></i></li>
                    <li><i class="lnr lnr-power-switch"></i></li>
                    <li><i class="lnr lnr-bubble"></i></li>
                    <li><i class="lnr lnr-heart-pulse"></i></li>
                    <li><i class="lnr lnr-pie-chart"></i></li>
                    <li><i class="lnr lnr-chart-bars"></i></li>
                    <li><i class="lnr lnr-gift"></i></li>
                    <li><i class="lnr lnr-diamond"></i></li>
                    <li><i class="lnr lnr-dinner"></i></li>
                    <li><i class="lnr lnr-coffee-cup"></i></li>
                    <li><i class="lnr lnr-leaf"></i></li>
                    <li><i class="lnr lnr-paw"></i></li>
                    <li><i class="lnr lnr-rocket"></i></li>
                    <li><i class="lnr lnr-briefcase"></i></li>
                    <li><i class="lnr lnr-bus"></i></li>
                    <li><i class="lnr lnr-car"></i></li>
                    <li><i class="lnr lnr-train"></i></li>
                    <li><i class="lnr lnr-bicycle"></i></li>
                    <li><i class="lnr lnr-wheelchair"></i></li>
                    <li><i class="lnr lnr-select"></i></li>
                    <li><i class="lnr lnr-earth"></i></li>
                    <li><i class="lnr lnr-smile"></i></li>
                    <li><i class="lnr lnr-sad"></i></li>
                    <li><i class="lnr lnr-neutral"></i></li>
                    <li><i class="lnr lnr-mustache"></i></li>
                    <li><i class="lnr lnr-alarm"></i></li>
                    <li><i class="lnr lnr-bullhorn"></i></li>
                    <li><i class="lnr lnr-volume-high"></i></li>
                    <li><i class="lnr lnr-volume-medium"></i></li>
                    <li><i class="lnr lnr-volume-low"></i></li>
                    <li><i class="lnr lnr-volume"></i></li>
                    <li><i class="lnr lnr-mic"></i></li>
                    <li><i class="lnr lnr-hourglass"></i></li>
                    <li><i class="lnr lnr-undo"></i></li>
                    <li><i class="lnr lnr-redo"></i></li>
                    <li><i class="lnr lnr-sync"></i></li>
                    <li><i class="lnr lnr-history"></i></li>
                    <li><i class="lnr lnr-clock"></i></li>
                    <li><i class="lnr lnr-download"></i></li>
                    <li><i class="lnr lnr-upload"></i></li>
                    <li><i class="lnr lnr-enter-down"></i></li>
                    <li><i class="lnr lnr-exit-up"></i></li>
                    <li><i class="lnr lnr-bug"></i></li>
                    <li><i class="lnr lnr-code"></i></li>
                    <li><i class="lnr lnr-link"></i></li>
                    <li><i class="lnr lnr-unlink"></i></li>
                    <li><i class="lnr lnr-thumbs-up"></i></li>
                    <li><i class="lnr lnr-thumbs-down"></i></li>
                    <li><i class="lnr lnr-magnifier"></i></li>
                    <li><i class="lnr lnr-cross"></i></li>
                    <li><i class="lnr lnr-menu"></i></li>
                    <li><i class="lnr lnr-list"></i></li>
                    <li><i class="lnr lnr-chevron-up"></i></li>
                    <li><i class="lnr lnr-chevron-down"></i></li>
                    <li><i class="lnr lnr-chevron-left"></i></li>
                    <li><i class="lnr lnr-chevron-right"></i></li>
                    <li><i class="lnr lnr-arrow-up"></i></li>
                    <li><i class="lnr lnr-arrow-down"></i></li>
                    <li><i class="lnr lnr-arrow-left"></i></li>
                    <li><i class="lnr lnr-arrow-right"></i></li>
                    <li><i class="lnr lnr-move"></i></li>
                    <li><i class="lnr lnr-warning"></i></li>
                    <li><i class="lnr lnr-question-circle"></i></li>
                    <li><i class="lnr lnr-menu-circle"></i></li>
                    <li><i class="lnr lnr-checkmark-circle"></i></li>
                    <li><i class="lnr lnr-cross-circle"></i></li>
                    <li><i class="lnr lnr-plus-circle"></i></li>
                    <li><i class="lnr lnr-circle-minus"></i></li>
                    <li><i class="lnr lnr-arrow-up-circle"></i></li>
                    <li><i class="lnr lnr-arrow-down-circle"></i></li>
                    <li><i class="lnr lnr-arrow-left-circle"></i></li>
                    <li><i class="lnr lnr-arrow-right-circle"></i></li>
                    <li><i class="lnr lnr-chevron-up-circle"></i></li>
                    <li><i class="lnr lnr-chevron-down-circle"></i></li>
                    <li><i class="lnr lnr-chevron-left-circle"></i></li>
                    <li><i class="lnr lnr-chevron-right-circle"></i></li>
                    <li><i class="lnr lnr-crop"></i></li>
                    <li><i class="lnr lnr-frame-expand"></i></li>
                    <li><i class="lnr lnr-layers"></i></li>
                    <li><i class="lnr lnr-funnel"></i></li>
                    <li><i class="lnr lnr-text-format"></i></li>
                    <li><i class="lnr lnr-text-format-remove"></i></li>
                    <li><i class="lnr lnr-text-size"></i></li>
                    <li><i class="lnr lnr-bold"></i></li>
                    <li><i class="lnr lnr-italic"></i></li>
                    <li><i class="lnr lnr-underline"></i></li>
                    <li><i class="lnr lnr-strikethrough"></i></li>
                    <li><i class="lnr lnr-highlight"></i></li>
                    <li><i class="lnr lnr-text-align-left"></i></li>
                    <li><i class="lnr lnr-text-align-center"></i></li>
                    <li><i class="lnr lnr-text-align-right"></i></li>
                    <li><i class="lnr lnr-text-align-justify"></i></li>
                    <li><i class="lnr lnr-line-spacing"></i></li>
                    <li><i class="lnr lnr-indent-increase"></i></li>
                    <li><i class="lnr lnr-indent-decrease"></i></li>
                    <li><i class="lnr lnr-pilcrow"></i></li>
                    <li><i class="lnr lnr-direction-ltr"></i></li>
                    <li><i class="lnr lnr-direction-rtl"></i></li>
                    <li><i class="lnr lnr-page-break"></i></li>
                    <li><i class="lnr lnr-sort-alpha-asc"></i></li>
                    <li><i class="lnr lnr-sort-amount-asc"></i></li>
                    <li><i class="lnr lnr-hand"></i></li>
                    <li><i class="lnr lnr-pointer-up"></i></li>
                    <li><i class="lnr lnr-pointer-right"></i></li>
                    <li><i class="lnr lnr-pointer-down"></i></li>
                    <li><i class="lnr lnr-pointer-left"></i></li>
                </ul>
            </div>
        </div>
    </div>
</section>
<!-- END: icons/linear-icons-free -->
